import authorityPNG from '~/assets/images/communication/what-authority-skills.png'
import authorityWEBP from '~/assets/images/communication/what-authority-skills.webp'
import InfoPage from '~/pages/communication/libs/InfoPage'
import { TPageProps } from '~/shared/types/commonTypes'

const AuthorityCommunication = (props: TPageProps) => (
  <InfoPage
    {...props}
    question="So, what are authority skills?"
    titleI18nKey="onboarding.communicationAuthority.title"
    subtitleI18nKey="onboarding.communicationAuthority.subtitle"
    imagePng={authorityPNG}
    imageWebp={authorityWEBP}
    imageAlt="So, what are authority skills?"
    imageFade
  />
)

export default AuthorityCommunication
